export const POSITION_COORDS = {
  CF:  { x: 200, y: 110 },
  LF:  { x: 75,  y: 148 },
  RF:  { x: 325, y: 148 },
  SS:  { x: 155, y: 210 },
  "2B":{ x: 245, y: 210 },
  "3B":{ x: 115, y: 265 },
  "1B":{ x: 285, y: 265 },
  C:   { x: 200, y: 308 },
  DH:  { x: 44,  y: 278 },
};

export const POSITIONS = ["CF", "LF", "RF", "SS", "2B", "3B", "1B", "C", "DH"];

export const toX = (x) => `${(x / 400) * 100}%`;
export const toY = (y) => `${((y - 65) / 280) * 100}%`;
